import React, { useState } from "react";
import { Card } from "./card";
import { IconButton, InputBase, List, Paper } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close'
import { theme } from "../theme/theme";
import { Info } from "../types/types";


interface SearchBarProps {
    info: Array<Info>
}

export const SearchBar = ({ info }: SearchBarProps) => {
    const [currentSearch, setState] = useState("")

    return <>
        <Paper
            sx={{
                marginTop: '1rem',
                display: 'flex',
                alignItems: 'center',
                padding: "3px",
            }}
        >
            <SearchIcon sx={{ margin: "10px" }} />
            <InputBase
                sx={{ ml: 1, flex: 1 }}
                placeholder="Search (Cases Insensitive)"
                inputProps={{ 'aria-label': 'Search' }}
                value={currentSearch}
                onChange={(event) => { setState(event.target.value.toLowerCase()) }}
            />
            {
                currentSearch !== "" ?
                    <IconButton onClick={() => { setState("") }}>
                        <CloseIcon />
                    </IconButton>
                    : <></>
            }
        </Paper>
        <Paper
            sx={{
                display: "flex",
                flexFlow: "column",
                overflow: "auto",
                marginTop: '1rem',
                alignItems: 'center',
                width: '100%',
                backgroundColor: theme.palette.background.default,
            }}
        >
            <List>
                {info
                    .filter(({ title, link, description }) => title.toLowerCase().includes(currentSearch) || link.toLowerCase().includes(currentSearch) || description.toLowerCase().includes(currentSearch))
                    .map((info: Info) => <Card info={info} />)}
            </List>
        </Paper>
    </>
}